import React, { useState, useEffect, useContext } from 'react';
// Make sure to import the CSS file as previously discussed
import { PracticeJerseyOrderContext } from './PracticeJerseyBuilder';
import { TrashFill } from 'react-bootstrap-icons';
export function parseNumberList(input) {
    const parts = input.split(',');
    const numbers = [];

    parts.forEach(part => {
        if (part.includes('-')) {
            const [start, end] = part.split('-').map(Number);
            for (let i = start; i <= end; i++) {
                numbers.push(i);
            }
        } else {
            numbers.push(Number(part));
        }
    });

    return [...new Set(numbers)].sort((a, b) => a - b);
}

export const createNumberList = (numbers = []) => {
    if (!Array.isArray(numbers)) {
        return '';
    }
    return numbers.join(',');
};

const SizeOption = ({ size, handleSetSize, autoSequence, includeNames, includeNumbers, productNum }) => {
    const { sizeData } = useContext(PracticeJerseyOrderContext);

    const [hasSize, setHasSize] = useState("");
    const [thisSizeData, setThisSizeData] = useState({});
    const [includeOption, setIncludeOption] = useState(false);

    const handleIncludeOptionChange = () => {
        setIncludeOption(!includeOption);
    };

    const handleNumberOptions = (value) => {
        setHasSize(value);
        let numbers = parseNumberList(value);
        doSizeUpdate(numbers.length, numbers);
    };

    const updateNumber = (number, index) => {
        number = number.replace(/\D/g, '');
        if (number === '0' || number === '00') {
            number = '00';
        }
        if (number.length > 3) {
            number = number.slice(0, 3);
        }
        let numbers = [...(thisSizeData.sizeNumbers || Array.from({ length: thisSizeData.qty }, (_, i) => i + 1))];
        numbers[index] = number;
        doSizeUpdate(thisSizeData.qty, numbers);
    };

    const updateName = (name, index) => {
        let names = [...(thisSizeData.sizeNames || Array.from({ length: thisSizeData.qty }, (_, i) => i + 1))];
        names[index] = name;
        doSizeUpdate(thisSizeData.qty, thisSizeData.sizeNumbers, names);
    };

    const doSizeUpdate = (qty, numbers, names) => {
        const adjustedSizeNames = names && names.length === qty
            ? names
            : (names || thisSizeData.sizeNames || []).map((x, i) => x ?? `name${i + 1}`);
    
        const adjustedSizeNumbers = numbers && numbers.length === qty
            ? numbers
            : (numbers || thisSizeData.sizeNumbers || []).map((x, i) => x ?? (i + 1));
    
        // Extend arrays if they are shorter than qty
        if (adjustedSizeNames.length < qty) {
            adjustedSizeNames.push(...Array.from({ length: qty - adjustedSizeNames.length }, (_, i) => `name${adjustedSizeNames.length + i + 1}`));
        }
    
        if (adjustedSizeNumbers.length < qty) {
            adjustedSizeNumbers.push(...Array.from({ length: qty - adjustedSizeNumbers.length }, (_, i) => adjustedSizeNumbers.length + i + 1));
        }
    
        let newSizeData = {
            size: size,
            sizeNames: adjustedSizeNames,
            sizeNumbers: adjustedSizeNumbers,
            qty: qty || thisSizeData.qty,
        };
        
        setThisSizeData(newSizeData);
        handleSetSize(size, newSizeData.qty, newSizeData.sizeNumbers, newSizeData.sizeNames);
    };
    
    const updateQty = (qty = 0) => {
        if (qty < 0) {
            qty = 0;
        }
        doSizeUpdate(qty);
    };

    const removeRow = (index) => {
        let newNumbers = [...(thisSizeData.sizeNumbers || [])];
        let newNames = [...(thisSizeData.sizeNames || [])];
        newNumbers.splice(index, 1);
        newNames.splice(index, 1);

        console.log(newNumbers, newNames, thisSizeData);
        doSizeUpdate(newNumbers.length, newNumbers, newNames);
    };

    useEffect(() => {
        if (includeOption && !thisSizeData.qty) {
            doSizeUpdate(1, thisSizeData.sizeNumbers);
        } else if (!includeOption) {
            handleSetSize(size, 0);
        }
    }, [includeOption]);

    useEffect(() => {
        const thisSizeData = sizeData.find((data) => data.size === size);
        setThisSizeData(thisSizeData || {});
        setIncludeOption(thisSizeData?.qty > 0);
    }, [sizeData]);

    useEffect(() => {
        if (!autoSequence) {
            setHasSize(createNumberList(thisSizeData.sizeNumbers));
        }
    }, [autoSequence]);

    return (
        <div className="size-option" key={`size-option${size}-${productNum}`} id={`size-option${size}-${productNum}`}>
            <div className="size-header">
                <div className="include-option">
                    <input
                        type="checkbox"
                        id={`include-option-${size}`}
                        checked={includeOption}
                        onChange={handleIncludeOptionChange}
                    />
                </div>
                <h3><label htmlFor={`include-option-${size}`}>Size <b>{size}</b></label></h3>
                <div className="options">
                    {includeOption && <div className="qty">
                        {(autoSequence || includeNames) && <button onClick={() => updateQty(thisSizeData.qty - 1)}>-</button>}
                        <input type="number" onChange={(e) => updateQty(e.target.value)} value={thisSizeData.qty} />
                        {(autoSequence || includeNames) && <button onClick={() => updateQty(thisSizeData.qty + 1)}>+</button>}
                    </div>}
                </div>
            </div>
            <div className="size-body">
                {includeNames && includeOption ? (
                    Array.from({ length: thisSizeData.qty }, (_, i) => (
                        <div key={size + i} className="d-flex w-100 name-number">
                            {autoSequence ? (
                                <input type="text" className={`${size}-size-number`} id={`${size}-${i}-num`} value={thisSizeData.sizeNumbers[i] || i + 1} style={{ width: "50px" }} readOnly />
                            ) : (
                                <input type="text" value={thisSizeData.sizeNumbers[i] || i + 1} style={{ width: "50px" }} onChange={(e) => updateNumber(e.target.value, i)} />
                            )}
                            {thisSizeData.sizeNames && <input type="text" defaultValue={thisSizeData.sizeNames[i] || ""} onChange={(e) => updateName(e.target.value, i)} />}
                            <button onClick={() => removeRow(i)} aria-label="Remove Row">
                                <TrashFill />
                            </button>
                        </div>
                    ))
                ) : (
                    includeOption && includeNumbers && !autoSequence && (
                        <>
                            <input type="text" placeholder="Enter Numbers" className="numbers-input" onChange={(e) => handleNumberOptions(e.target.value)} value={hasSize} />
                            <span>Enter numbers in formats like: 1, 2, 4 or 1-3 or both: 2,8,10-15</span>
                        </>
                    )
                )}
            </div>
        </div>
    );
};

export default SizeOption;
